import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const BackIconWrapper = styled.div`
  height: 72px;
  padding: 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e2eb;
  background-color: white;
  opacity: 0.9;
  gap: 4px;
`;

export const FormWrapper = styled.div`
  height: calc(100vh - 72px);
  overflow: scroll;
`;
